// Generated at build time so the running bundle can identify itself.
export const BUILD_TIME = "2026-08-07 07:14";
export const BUILD_SHA = "93ee89c";
